import type React from "react";
import { HomeIcon } from "@heroicons/react/24/outline";
import {
  AlarmClockCheckIcon,
  CalendarDays,
  ClipboardIcon,
  CloudDownload,
  FileClock,
  FolderClosedIcon,
  BookOpenText,
  MessageSquareDot,
  UsersRound,
} from "lucide-react";
import { Feature } from "@/types/user";
export interface NavigationItem {
  name: string;
  current: boolean;
  href?: string;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  children?: NavigationItem[];
  requiredFeature?: Feature;
}

export type NavigationMenuProps = NavigationItem[];
export const NavigationSidebarItemsList: NavigationMenuProps = [
  { name: "Home", href: "/", icon: HomeIcon, current: false },
  {
    name: "Deadline Guardian",
    icon: AlarmClockCheckIcon,
    href: "/calendars",
    current: true,
    requiredFeature: "deadline_guardian",
  },
  { name: "My Folders", href: "/drive", icon: FolderClosedIcon, current: false },
  { name: "Shared with me", href: "/shared", icon: UsersRound, current: false },
  { name: "Sharepoint", href: "/sharepoint", icon: CloudDownload, current: false },
  { name: "SnapShot", href: "/snapshots", icon: ClipboardIcon, current: false },
  { name: "Open Chat", href: "/open-chat", icon: MessageSquareDot, current: false },
  { name: "Chronology", href: "/chronology-list", icon: FileClock, current: false },
  { name: "My Calendar", href: "/my-calendar", icon: CalendarDays, current: false },
  { name: "Prompt Library", href: "/prompt-library", icon: BookOpenText, current: false },
];
